import { COMMON } from "../../util/localizations";

const TRANSLATIONS = {
    en: {
        cantConnect: 'Unable to connect to MetaMask.',
        cantMintNewBoard: 'You must create a board before minting.',
        connect: 'Connect to MetaMask',
        connectedSuccessully: 'Successfully connected to MetaMask.',
        connectionAborted: 'Unable to connect to MetaMask. User aborted connection.',
        install: COMMON.en.install,
        mint: COMMON.en.mintToBlockchain
    }
}

export default TRANSLATIONS